/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import Text from '../../../../shared/components/Text/Text';
import { setActiveModal, setSelectedReduxCalendar } from '../../ducks/calendarActions';

const BreadCrumbsContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const BreadCrumb = styled('div')`
  &:hover {
    opacity: 0.7;
  }
`;

const BreadCrumbs = () => {
  const dispatch = useDispatch();
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedReduxNonDateBasedProgram = useSelector(
    (state) => state.calendar.data.selectedReduxNonDateBasedProgram,
  );
  const selectedCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const selectedReduxAthlete = useSelector((state) => state.calendar.data.selectedReduxAthlete);
  const parentCalendars = useSelector((state) => state.calendar.data.parentCalendars);

  // Check if the selected calendar has parent information
  const hasParentCalendar = selectedCalendar?.parentCalendarInfo
    && Object.keys(selectedCalendar.parentCalendarInfo).length > 0;

  const calendarNameWriter = () => {
    if (Object.keys(selectedCalendar).length) {
      return selectedCalendar?.name ? `${selectedCalendar?.name}` : 'Select Calendar';
    }
    if (Object.keys(selectedReduxAthlete).length) {
      return selectedReduxAthlete?.first && selectedReduxAthlete?.last ? `${selectedReduxAthlete?.first} ${selectedReduxAthlete?.last}` : 'Select Calendar';
    }
    return 'Select Calendar';
  };

  const programLibraryNameWriter = () => {
    if (Object.keys(selectedReduxNonDateBasedProgram).length) {
      return selectedReduxNonDateBasedProgram?.programName ? `${selectedReduxNonDateBasedProgram?.programName}` : 'Select Program';
    }
    return 'Select Program';
  };

  const isCalendarSelected = Object.keys(selectedCalendar).length > 0
    || (Object.keys(selectedReduxAthlete).length > 0
      && selectedReduxAthlete?.first
      && selectedReduxAthlete?.last);

  const isProgramSelected = Object.keys(selectedReduxNonDateBasedProgram).length > 0;

  const handleParentClick = () => {
    if (hasParentCalendar && parentCalendars) {
      // Find the parent calendar from the array of parentCalendars
      const parentCalendar = parentCalendars.find(
        (cal) => cal.id === selectedCalendar.parentCalendarInfo.id,
      );

      if (parentCalendar) {
        dispatch(setSelectedReduxCalendar(parentCalendar));
      } else {
        dispatch(setActiveModal('selectCalendarModal'));
      }
    } else {
      dispatch(setActiveModal('selectCalendarModal'));
    }
  };

  return (
    <BreadCrumbsContainer>
      <BreadCrumb onClick={() => (programType === 'free-form-program' ? dispatch(setActiveModal('selectProgramModal')) : dispatch(setActiveModal('selectCalendarModal')))}>
        {programType === 'free-form-program' ? (
          <Text fontSize='14px' color='rgba(158, 158, 158, 1)'>Programs</Text>
        ) : (
          <Text fontSize='14px' color='rgba(158, 158, 158, 1)'>Calendars</Text>
        )}
      </BreadCrumb>

      {/* Parent Calendar Breadcrumb - Only shown for subcalendars */}
      {hasParentCalendar && programType === 'calendar' && (
        <>
          <Text style={{ transform: 'rotate(15deg)', paddingLeft: 5, paddingRight: 5 }} fontSize='16px' color='rgba(158, 158, 158, 1)'> / </Text>
          <BreadCrumb onClick={handleParentClick}>
            <Text fontSize='14px' color='rgba(158, 158, 158, 1)'>{selectedCalendar.parentCalendarInfo.name}</Text>
          </BreadCrumb>
        </>
      )}

      {/* Current Calendar Breadcrumb */}
      {isCalendarSelected && programType === 'calendar' && (
        <>
          <Text style={{ transform: 'rotate(15deg)', paddingLeft: 5, paddingRight: 5 }} fontSize='16px' color='rgba(158, 158, 158, 1)'> / </Text>
          <BreadCrumb onClick={() => dispatch(setActiveModal('selectCalendarModal'))}>
            <Text fontSize='14px' color='rgba(158, 158, 158, 1)'>{calendarNameWriter()}</Text>
          </BreadCrumb>
        </>
      )}

      {/* Current Program Breadcrumb */}
      {isProgramSelected && programType === 'free-form-program' && (
        <>
          <Text style={{ transform: 'rotate(15deg)', paddingLeft: 5, paddingRight: 5 }} fontSize='16px' color='rgba(158, 158, 158, 1)'> / </Text>
          <BreadCrumb onClick={() => dispatch(setActiveModal('selectProgramModal'))}>
            <Text fontSize='14px' color='rgba(158, 158, 158, 1)'>{programLibraryNameWriter()}</Text>
          </BreadCrumb>
        </>
      )}
    </BreadCrumbsContainer>
  );
};

export default BreadCrumbs;
